//Global imports
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

//File imports
import StringUtils from '../../services/StringUtils/StringUtils';
import Notification from '../../services/Notification/Notification';
import Logger from '../../services/Logger/Logger';
import { DocumentCategoryService } from './Api/DocumentCategoryService';

//Component imports
import { Layout } from '../../components/Layout';
import { DocumentCategoryList } from './Components';
import CreateDocumentCategoryModal from './Components/CreateDocumentCategoryModal';

const DocumentCategory = () => {
    const stringUtils = new StringUtils();
    const notification = new Notification();
    const logger = new Logger();
    const navigate = useNavigate();
    const documentCategoryService = new DocumentCategoryService();

    const [modalVisible, setModalVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleTemplateCreated = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <Layout>
            <DocumentCategoryList
                notification={notification}
                stringUtils={stringUtils}
                documentCategoryService={documentCategoryService}
                logger={logger}
                key={refreshKey}
                navigate={navigate}
            />
            <CreateDocumentCategoryModal
                stringUtils={stringUtils}
                documentCategoryService={documentCategoryService}
                notification={notification}
                logger={logger}
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSuccess={handleTemplateCreated}
            />
        </Layout>
    );
};

export default DocumentCategory;
